import { render, staticRenderFns } from "./complianceDetail.vue?vue&type=template&id=40d47d8c"
import script from "./complianceDetail.vue?vue&type=script&lang=js"
export * from "./complianceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d47d8c')) {
      api.createRecord('40d47d8c', component.options)
    } else {
      api.reload('40d47d8c', component.options)
    }
    module.hot.accept("./complianceDetail.vue?vue&type=template&id=40d47d8c", function () {
      api.rerender('40d47d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/complianceDetail.vue"
export default component.exports